import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHandHoldingDollar, faWallet, faCreditCard, faArrowUpFromBracket, faCircleNotch, faArrowRight, faUser } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { useNavigate, useLocation, Link } from 'react-router-dom'

//FILE UPLOAD
import { FilePond, registerPlugin } from 'react-filepond'
import 'filepond/dist/filepond.min.css'
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview)

function Deposit3() {
  const { user } = useUser();
  const [loading, setLoading] = useState(true);
  const { state } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (!localStorage.getItem('deposit.type')) {
        navigate('/deposit1', { replace: true })
    }else{
        setLoading(false);
    }
  }, [state, navigate])
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [symbol, setSymbol] = useState(() => {return state?.symbol ?? localStorage.getItem('deposit.symbol') ?? '';});
  const [address, setAddress] = useState(() => {return state?.address ?? localStorage.getItem('deposit.address') ?? '';});
  const [method, setMethod] = useState(() => {return state?.method ?? localStorage.getItem('deposit.method') ?? '';});
  const [network, setNetwork] = useState(() => {return state?.network ?? localStorage.getItem('deposit.network') ?? '';});
  const [route, setRoute] = useState(() => {return state?.route ?? localStorage.getItem('deposit.route') ?? 'funding';});
  const [type, setType] = useState(() => {return state?.type ?? localStorage.getItem('deposit.type') ?? 'crypto';});
  const [amount, setAmount] = useState(() => {return state?.amount ?? localStorage.getItem('deposit.amount') ?? '';});
  const [files, setFiles] = useState([])
  const [fileName, setFileName] = useState(localStorage.getItem('deposit.filename') || '')
  const [disable, setDisable] = useState(true);
  useEffect(() => {
    if(fileName){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [fileName]);
  
  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Deposit" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Deposit" icon={<FontAwesomeIcon icon={faHandHoldingDollar} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="container mt-5">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2 mb-5">
                        <h5 className="mb-0" style={{fontWeight:'900'}}>Make a Deposit</h5>
                        <p className="mb-0">Add funds to your trading account</p>
                        <div className="mt-5 d-flex align-items-center progressD" style={{gap:'20px'}}>
                          <Link to="/deposit" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                              <FontAwesomeIcon icon={faUser} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-prime text-nowrap" style={{fontSize:'12px'}}>Deposit Type</p>
                          </Link>
                          <div style={{height:'3px',maxWidth:'200px',width:'100%'}} className="bg-prime"></div>
                          <Link to="/deposit1" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                              <FontAwesomeIcon icon={faWallet} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-prime text-nowrap" style={{fontSize:'12px'}}>Deposit Method</p>
                          </Link>
                          <div style={{height:'3px',maxWidth:'200px',width:'100%'}} className="bg-prime"></div>
                          <Link to="/deposit2" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',}}>
                              <FontAwesomeIcon icon={faCreditCard} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-prime text-nowrap" style={{fontSize:'12px'}}>Deposit Details</p>
                          </Link>
                          <div className="bg-prime" style={{height:'3px',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/deposit3" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                              <FontAwesomeIcon icon={faArrowUpFromBracket} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap text-prime" style={{fontSize:'12px'}}>Payment Proof</p>
                          </Link>
                          <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                          <Link to="/deposit4" className="d-flex flex-column align-items-center noLink">
                            <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                              <FontAwesomeIcon icon={faCircleCheck} style={{fontSize: '16px'}} />
                            </div>
                            <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Review & Submit</p>
                          </Link>
                        </div>
                        <div className="mycard p-3 mt-4">
                          <div className="row">
                            <div className="col-12 largeSelect">
                              <h5 className="mb-4" style={{fontWeight:'900'}}>Upload Payment Proof</h5>
                              <FilePond
                                files={files}
                                onupdatefiles={setFiles}
                                allowMultiple={false}
                                maxFiles={3}
                                name="file"
                                labelIdle="Click here to upload payment proof"
                                server={{
                                  process: (fieldName, file, metadata, load, error, progress, abort) => {
                                    const formData = new FormData();
                                    formData.append("file", file);
                                    const request = new XMLHttpRequest();
                                    request.open("POST", `${process.env.REACT_APP_API_URL}controller/upload.php`);
                                    request.upload.onprogress = (e) => {
                                      progress(e.lengthComputable, e.loaded, e.total);
                                    };
                                    request.onload = () => {
                                      const res = JSON.parse(request.responseText);
                                      if (res.success) {
                                        setFileName(res.filename);
                                        load(res.filename);
                                      } else {
                                        error(res.error || "Upload failed");
                                      }
                                    };
                                    request.onerror = () => {
                                      error("Upload error");
                                    };
                                    request.send(formData);
                                    return {
                                      abort: () => {
                                        request.abort();
                                        abort();
                                      }
                                    };
                                  },
                                  revert: (serverId, load, error) => {
                                    fetch(`${process.env.REACT_APP_API_URL}controller/delete.php`, {
                                      method: "POST",
                                      headers: {
                                        "Content-Type": "application/json"
                                      },
                                      body: JSON.stringify({ filename: fileName })
                                    })
                                      .then((res) => res.json())
                                      .then((data) => {
                                        if (data.success) {
                                          setFileName("");
                                          setFiles([]);
                                          load();
                                        } else {
                                          error(data.error || "Failed to delete file");
                                        }
                                      })
                                      .catch(() => {
                                        error("Delete request failed");
                                      });
                                  }
                                }}
                              />
                              <hr/>
                              <div className="d-flex justify-content-end">
                                {disable ? (
                                  <div className="myBtn mt-4 text-center px-4 py-3 rounded-2" disabled>Next <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '14px'}} /></div>
                                ) : (
                                  <Link to="/deposit4" state={{symbol:symbol, address:address, route:route, method:method, network:network, type:type, filename : fileName, amount: amount}} className="myBtn mt-4 text-center px-4 py-3 rounded-2" 
                                  onClick={() => { 
                                    localStorage.setItem('deposit.fileName', fileName);
                                  }}>Next <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '14px'}}/></Link>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Deposit3